namespace $ {

	/** Semantic colors for operation states. */
	export const $shm_theme = $mol_style_prop(
		'shm_theme',
		[
			'success',
			'active',
			'error',
		] as const,
	)

}
